module.exports = __webpack_public_path__ + "static/media/active-explore.2593d598.svg";